import React, { useEffect, useState } from 'react';
import { UserSummaryType } from '../../api/types/user/user-summary.type';
import { UserPageStudent } from './roles/user-page-student';
import { UserType } from '../../api/types/user/user-type';
import { UserPageLecture } from './roles/user-page-lecture';
import { UserPageAdministration } from './roles/user-page-administration';
import { getUserDetailsOperation } from './operations/get-user-details-operation';
import { UserAvatarSmall } from '../../component/user-avatar/user-avatar-small';
import { Button } from 'primereact/button';

interface UserPageDatamodel {
  user: UserSummaryType;
  closeDialog: () => void;
  userRole: UserType | undefined;
}

interface UserPageHeaderProps {
  user: UserSummaryType;
  userRole: UserType;
  closeDialog: () => void;
}

const UserPageHeader: React.FC<UserPageHeaderProps> = ({
  user,
  userRole,
  closeDialog,
}) => {
  const getHeaderConfig = (userRole: UserType) => {
    switch (userRole) {
      case UserType.STUDENT:
        return {
          title: 'סטודנטים',
          backgroundColor: '#f0f7ff',
          borderColor: '#0066cc',
          textColor: '#0066cc',
        };
      case UserType.LECTURER:
        return {
          title: 'מרצים',
          backgroundColor: '#f0fff4',
          borderColor: '#00994d',
          textColor: '#00994d',
        };
      case UserType.ADMINISTRATION:
        return {
          title: 'מנהלה',
          backgroundColor: '#f8f0ff',
          borderColor: '#6600cc',
          textColor: '#6600cc',
        };
      default:
        return {
          title: 'משתמש',
          backgroundColor: '#f5f5f5',
          borderColor: '#666',
          textColor: '#666',
        };
    }
  };

  const config = getHeaderConfig(userRole);

  return (
    <div
      style={{
        backgroundColor: config.backgroundColor,
        borderLeft: `4px solid ${config.borderColor}`,
        padding: '16px 20px',
        marginBottom: '16px',
        borderRadius: '8px',
        direction: 'rtl',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <UserAvatarSmall
            imageUrl={user?.fileUrl}
            firstName={user?.firstName}
            lastName={user?.lastName}
          />
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: '1.5rem',
                color: config.textColor,
                fontWeight: 'bold',
              }}
            >
              {config.title}
            </h2>
            <h3
              style={{ margin: '4px 0 0 0', fontSize: '1.1rem', color: '#333' }}
            >
              {user.firstName} {user.lastName}
            </h3>
            <p
              style={{ margin: '2px 0 0 0', color: '#666', fontSize: '0.9rem' }}
            >
              {user.email}
            </p>
          </div>
        </div>
        <Button
          icon="pi pi-times"
          className="p-button-text p-button-rounded"
          onClick={closeDialog}
          tooltip="סגור"
          style={{ color: config.textColor }}
        />
      </div>
    </div>
  );
};

export const UserPage: React.FC<UserPageDatamodel> = ({
  user,
  closeDialog,
  userRole,
}) => {
  useEffect(() => {
    const fetchUserDetail = async () => {
      await getUserDetailsOperation(user, closeDialog, userRole);
    };
    fetchUserDetail();
  }, []);

  const getUserRolePage = (userRole: UserType) => {
    user.role = userRole;
    switch (userRole) {
      case UserType.LECTURER:
        return <UserPageLecture user={user} />;
      case UserType.ADMINISTRATION:
        return <UserPageAdministration user={user} />;
      case UserType.STUDENT:
        return <UserPageStudent user={user} />;
    }
  };

  const currentUserRole = userRole ?? user.role;

  return (
    <div>
      {/*      <UserPageHeader
        user={user}
        userRole={currentUserRole}
        closeDialog={closeDialog}
      />*/}
      {getUserRolePage(currentUserRole)}
    </div>
  );
};
